export default {"src":"/_next/static/media/marketplace.2352600d.svg","height":32,"width":32};